<template>
  <div class="changePosition">
    <div class="left ellipsis">
      <q-icon
        size="20px"
        class="beforeIcon vertical-middle q-mr-xs"
        name="font:dm-location"
      />
      <span v-if="adderss">{{ adderss }}</span>
      <span v-else>{{ $t('home.nearest.location') }}</span>
    </div>
    <q-btn no-caps flat :label="$t('common.change')" @click="$emit('showMap')" />
  </div>
</template>

<script>
export default {
  props: {
    adderss: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.changePosition {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f3f4f6;
  border-radius: 10px;
  padding: 8px;
  .left {
    display: flex;
    align-items: self-end;
  }
  .q-btn {
    font-weight: 800;
    font-size: 12px;
    line-height: 1px;
    color: $primary;
    .q-btn__wrapper {
      padding: 0;
    }
  }
}
</style>
